import SectionMessage from '@atlaskit/section-message';
import { Code } from '@atlaskit/code';
import * as React from 'react';
export default {
  SectionMessage,
  Code,
  React
};